/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconFishHook = createReactComponent("fish-hook", "IconFishHook", [
  ["path", { d: "M16 9v6a5 5 0 0 1 -10 0v-4l3 3", key: "svg-0" }],
  ["path", { d: "M16 7m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", key: "svg-1" }],
  ["path", { d: "M16 5v-2", key: "svg-2" }]
]);

export { IconFishHook as default };
//# sourceMappingURL=IconFishHook.js.map
